export interface IFocusArea {
  x: number;
  y: number;
  width: number;
  height: number;
  weight: number;
}
export type IFocusAreaArray = [number, number, number, number, number];
export function focusAreaToArray(
  focusArea: IFocusArea | IFocusAreaArray
): IFocusAreaArray {
  if (Array.isArray(focusArea)) {
    return focusArea;
  }
  const { x, y, width, height, weight } = focusArea;
  return [x, y, width, height, weight];
}
